export const scheduledMessages = state => state.scheduledMessages


// WEBPACK FOOTER //
// ./src/modules/whatsapp-api/getters.js